// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M16.4142 3.00003L14.4142 5.00003H19.5V14.645C20.9457 15.0752 22 16.4145 22 18C22 19.933 20.433 21.5 18.5 21.5C16.567 21.5 15 19.933 15 18C15 16.4145 16.0543 15.0752 17.5 14.645V7.00003H14.4142L16.4142 9.00003L15 10.4142L10.5858 6.00003L15 1.58582L16.4142 3.00003ZM2 6.00003C2 4.06703 3.567 2.50003 5.5 2.50003C7.433 2.50003 9 4.06703 9 6.00003C9 7.58554 7.94574 8.92482 6.5 9.35509V14.645C7.94574 15.0752 9 16.4145 9 18C9 19.933 7.433 21.5 5.5 21.5C3.567 21.5 2 19.933 2 18C2 16.4145 3.05426 15.0752 4.5 14.645V9.35509C3.05426 8.92482 2 7.58554 2 6.00003Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-git-pull-request-filled')
export default class GitPullRequestFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'git-pull-request-filled',
    }
  }
}
